// extracted by mini-css-extract-plugin
export default {"emptyState":"RequestAuditTrails_emptyState__wUYgJ","loadingContainer":"RequestAuditTrails_loadingContainer__HnJoq"};